import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {XMLHttpRequestHandler} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {transactionsList_template} from "../components/templates/transactionsList_template";
import {header} from "./header";
import { XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";

declare var ko: any;
declare var page: any;

export class transactions extends vnModule_knockoutJS {

    protected XHRHdl: XMLHttpRequestHandler;
    protected listTemplate: transactionsList_template;
    protected XHRHdls: XMLHttpRequestHandler[] = [];

    protected getModuleName() {

        return "transactions";
    }

    buildContent(): Array<Element> {

        // create the topics list
        this.listTemplate = new transactionsList_template("list", this.viewModel, this);
        this.template = this.listTemplate;

        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        let title = "Transactions List";
        let idBrand = this.getTransactionSystem();
        if (idBrand == 'VN') {
            title = 'Network Transactions'
        }
        (<header>loadedModule).setHeaderTitle(title);

        let transactionSystem = this.getTransactionSystem();

        this.listTemplate.setTransactionSystem(transactionSystem);

        return [this.listTemplate.build()];
    }

    public fillPage(): void {

        // init calendar
        // ** this need to be done AFTER the element is inserted in the page
        // as it uses query selector to load the calendars
        this.listTemplate.buildDatePickerCalendar();
        this.getfilterReference();
    }

    protected getfilterReference() {

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        let usrReq_url: string;

        usrReq_url = '/api/transactions/references';

        let usrReq_params: Array<Array<string>> = [];
        let isFromNetwork = false;
        if (this.getVnAppZone().app.params.idBrand == undefined) {
            isFromNetwork = true;
        }

        usrReq_params.push(["data", ko.toJSON({isFromNetwork: isFromNetwork})]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        let localCheck = this.XHRHdl.requestId;
        let _myThis = this;
        setTimeout(function () {

            if (localCheck == _myThis.XHRHdl.requestId) {
                _myThis.XHRHdl.onReadyStateFunction = _myThis.onGetfilterReferenceRequestReturn;
                _myThis.XHRHdl.execute();
            }
        }, 400);
    }

    protected onGetfilterReferenceRequestReturn(req, obj) {

        return function () {

            if (req.request.readyState == 4) {

                let responseParsed = JSON.parse(req.request.response);

                if (req.request.status == 200) {

                    obj.listTemplate.validationsList.clearMessages();
                    obj.updateReferenceList(responseParsed.data);

                    obj.updateViewModelFromPath();
                    obj.getSearchPresetsListData();

                    obj.filterList()
                } else if (req.request.status == "423") {

                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, responseParsed.message);
                    obj.getVnAppZone().showNotificationToModule();
                    let url: string;
                    if (obj.getVnAppZone().app.params.idBrand) {
                        url = '/' + obj.getVnAppZone().app.params.idBrand + '/home';
                    } else {
                        url = '/';
                    }
                    page.redirect(url);
                } else {

                    obj.listTemplate.onUpdateError(req.request.status, responseParsed);
                }

            }
        }
    }

    protected filterList() {

        // LOADING : starts
        this.listTemplate.activateLoading();

        //
        // get the short anem of the brand ot make the call to the API
        let transactionSystem = this.getTransactionSystem();

        //
        // build ther ight url for the API call
        let usrReq_url: string;
        usrReq_url = '/api/' + transactionSystem + '/transactions/get/';
        let _myThis = this;
        setTimeout(function () {

            let subViewModel = _myThis.listTemplate.getViewModelForRequest();
            _myThis.sendFilterCall(usrReq_url, subViewModel, _myThis.onFilterRequestReturn, XMLHttpRequestHandler_requestType.GET, 'transactions');
        }, 400);
    }

    protected onFilterRequestReturn(req, obj) {

        return function () {

            return obj.manageResponse(req, obj, function () {

                let response = JSON.parse(req.request.response);
                const {totalCount, totalPage} = response.data
                let execTime = Math.round((new Date().getTime() - req.requestStartTime) / 1000 * 100) / 100
                obj.listTemplate.validationsList.clearMessages();
                obj.listTemplate.setResultInfo(totalCount, totalPage, execTime );
                obj.updateList(response);

                obj.listTemplate.deactivateLoading();
            });
        }
    }

    protected paginationOnPageClick() {
        this.filterList();
    }

    protected updateList(responseParsed: any) {

        // set users list
        let payments = [];
        for (let item of responseParsed.data.data) {

            payments.push(item)
        }

        this.listTemplate.setPayments(payments, this.getBrandId());

        // update the paginator
        this.viewModel.list.pagination.itemCount(responseParsed.data.totalCount);
    }

    protected updateReferenceList(response: any) {

        this.listTemplate.setPaymentItemTypeFilterOptions(response.itemTypes);
        this.listTemplate.setPaymentStatusFilterItems(response.statuses);
        this.listTemplate.setPaymentCreationTypeFilterItems(response.creationTypes);
        this.listTemplate.setPaymentRoleFilterItems(response.roles);
        this.listTemplate.setPaymentActionTypeFilterItems(response.actionTypes)
        this.listTemplate.setPaymentTypeFilterItems(response.types);
        this.listTemplate.setPaymentEntryTypeFilterItems(response.entryTypes);
        this.listTemplate.setPaymentCurrencyFilterItems(response.currencies);
        this.listTemplate.setPaymentTimePeriodFilterItems(response.periods);
        this.listTemplate.setBrandFilterItems(this.getUserBrands());
        this.listTemplate.setPaymentAccountsFilterItems(response.accounts)
        this.listTemplate.setPaymentArticleGroupsFilterItems(response.articleGroups)

        this.listTemplate.setCanEditTransactions(response.permissions.trx_edit.write);
        this.listTemplate.setCanDeleteTransactions(response.permissions.trx_edit.delete);
        this.listTemplate.setCanSearchUsers(response.permissions.trx_edit.read);
    }

    protected filterDateOnChange() {
        // on keywords filtering, always set the page back to 1.
        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterDropdownOnChange() {
        // on keywords filtering, always set the page back to 1.
        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected getUsersSuggestion(keyword) {

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        let subViewModel = {list: {keyword: keyword}};
        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + "/search/user/";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetUsersSuggestionsReturn;
        this.XHRHdl.execute();
    }

    protected onGetUsersSuggestionsReturn(req, obj) {

        return function () {

            if (req.request.readyState == 4) {

                let responseParsed = JSON.parse(req.request.response);

                if (req.request.status == 200) {
                    obj.listTemplate.validationsList.clearMessages();
                    if (responseParsed.data.users) {
                        obj.listTemplate.setUsers(responseParsed.data.users);
                    }
                } else if (req.request.status == "423") {
                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, responseParsed.message);
                    obj.getVnAppZone().showNotificationToModule();
                } else {
                    obj.listTemplate.onUpdateError(req.request.status, responseParsed);
                }

                // LOADING : ends
                obj.listTemplate.deactivateLoading();
            }
        }

    }

    protected getArticlesSuggestion(keyword) {

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        let subViewModel = {list: {keyword: keyword}};
        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + "/search/article/";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetArticlesSuggestionsReturn;
        this.XHRHdl.execute();
    }

    protected onGetArticlesSuggestionsReturn(req, obj) {

        return function () {

            if (req.request.readyState == 4) {

                let responseParsed = JSON.parse(req.request.response);

                if (req.request.status == 200) {
                    if (responseParsed.data.articles) {
                        obj.listTemplate.setArticles(responseParsed.data.articles);
                    }
                } else if (req.request.status == "423") {
                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, responseParsed.message);
                    obj.getVnAppZone().showNotificationToModule();
                } else {
                    obj.listTemplate.onUpdateError(req.request.status, responseParsed);
                }

                // LOADING : ends
                obj.listTemplate.deactivateLoading();
            }
        }
    }

    protected addTransaction() {
        this.saveViewModule(this.getMemoryViewModel());

        let idBrand = this.getVnAppZone().app.params.idBrand;
        let url: string;
        url = '/brand/' + idBrand + '/payment/transactions/add';
        if (idBrand == undefined || idBrand == 'undefined') {
            url = '/payment/transactions/add';
        }

        page(url);
    }

    protected getMemoryViewModel(){

        return this.listTemplate.getTemplateViewModel();
    }

    protected editTransaction(id) {

        this.saveViewModule(this.getMemoryViewModel());
        let url: string;

        let idBrand = this.getVnAppZone().app.params.idBrand;
        url = '/brand/' + idBrand + '/payment/transactions/edit/' + id;
        if (idBrand == undefined || idBrand == 'undefined') {
            url = '/payment/transactions/edit/' + id;

        }

        let editUrl = window.location.origin+url
        this.savePreviousPage(editUrl, window.location.href);

        page(url);
    }

    protected deleteTransaction(id) {

        this.saveViewModule(this.getMemoryViewModel());

        let idBrand = this.getBrandId();
        let url: string = '/brand/' + idBrand + '/payment/transactions/delete/' + id;
        if (idBrand == undefined || idBrand == 'undefined') {

            url = '/payment/transactions/delete/'+ id;
        }

        page(url);
    }

    private getBrandId() {
        return this.getVnAppZone().app.params.idBrand;
    }

    protected transactionListReorder() {

        this.filterList();
    }

    protected filterSimpleOnChange() {
        this.filterList();
    }

    protected filterSimpleCancel(){

    }

    public getTransactionSystem(){

        let transactionSystem = "VN";
        let vnApp = this.getVnAppZone().app;
        for ( let b of vnApp.loggedUser.user.brands ) {

            if( b.id == this.getVnAppZone().app.params.idBrand){

                transactionSystem = b.shortName;
            }
        }

        return transactionSystem;
    }


    protected filterMultipleSelectorOnChange(){
        this.listTemplate.setEnableTimePeriodFilter(this.listTemplate.showPeriodTimesFilter());
        this.listTemplate.setEnableArticleGroupFilter(this.listTemplate.showArticleGroupsFilter());
        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    public getUserBrands(): Array<{id: number, name: string}> {

        let vnApp = this.getVnAppZone().app;

        return vnApp.loggedUser.user.brands;
    }

    protected saveSearchPreset(){

        if( "saveSearchPreset" in this.XHRHdl ){
            this.XHRHdls["saveSearchPreset"].cancelAndReset();
        }

        let formReq_url: string = '/api/search_preset/save';
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = JSON.parse(ko.toJSON(this.listTemplate.getViewModelForRequest()));

        formReq_params.push(["data", ko.toJSON(subViewModel)] );

        this.XHRHdls['saveSearchPreset'] = new XMLHttpRequestHandler(formReq_url,formReq_params, this);

        this.XHRHdls['saveSearchPreset'].mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdls['saveSearchPreset'].onReadyStateFunction = this.onPostSearchPresetArticles
        this.XHRHdls['saveSearchPreset'].execute();
    }

    private onPostSearchPresetArticles(req, obj): Function {
        return function () {
            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);

                obj.listTemplate.addCreatedPresetToList(response);

            });

        }
    }

    protected saveFavoriteSearchPreset( params: {presetId: number, searchPresetType: string}): void {

        if( "saveFavoriteSearchPreset" in this.XHRHdls ){
            this.XHRHdls["saveFavoriteSearchPreset"].cancelAndReset();
        }
        let formReq_url: string = '/api/search_preset/favorite/save/';
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = JSON.parse(ko.toJSON(params));

        formReq_params.push(["data", ko.toJSON(subViewModel)]);

        this.XHRHdls['saveFavoriteSearchPreset'] = new XMLHttpRequestHandler(formReq_url,formReq_params, this);

        this.XHRHdls['saveFavoriteSearchPreset'].mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdls['saveFavoriteSearchPreset'].onReadyStateFunction = this.onPostFavoriteSearchPresetArticles
        this.XHRHdls['saveFavoriteSearchPreset'].execute();
    }

    private onPostFavoriteSearchPresetArticles(req, obj): Function {
        return function () {
            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);

            });
        }
    }

    protected deleteSearchPreset(presetId: number): void {

        if( "deleteSearchPreset" in this.XHRHdls ){
            this.XHRHdls["deleteSearchPreset"].cancelAndReset();
        }

        let usrReq_url: string = '/api/search_preset/delete/' + presetId + '/';
        let usrReq_params: Array<Array<string>> = [];

        this.XHRHdls['deleteSearchPreset'] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdls['deleteSearchPreset'].onReadyStateFunction = this.onDeleteSearchPresetReturn;
        this.XHRHdls['deleteSearchPreset'].execute();
    }

    protected onDeleteSearchPresetReturn(req, obj): Function {

        return () => {

            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);

            });
        }
    }

    protected getSearchPresetsListData(): void {

        if( "getSearchPresetsListData" in this.XHRHdls ){
            this.XHRHdls["getSearchPresetsListData"].cancelAndReset();
        }

        let subViewModel = JSON.parse(ko.toJSON(this.listTemplate.getViewModelForRequest()));
        let usrReq_url: string = '/api/search_preset/get/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);

        this.XHRHdls['getSearchPresetsListData']= new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdls['getSearchPresetsListData'].onReadyStateFunction = this.onGetSearchPresetsReturn;
        this.XHRHdls['getSearchPresetsListData'].execute();
    }

    protected onGetSearchPresetsReturn(req, obj): Function {

        return () => {

            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);
                obj.listTemplate.setSearchPresets(response);
                obj.filterList();
            });
        }
    }

    protected setDefaultStatusFilters(){
        this.listTemplate.setDefaults();
    }

    protected filterByUrl(){
        this.updateViewModelFromPath();
        this.filterList();
    }

    protected filterByPresets(filters){
        this.listTemplate.setViewModelFromRequest(filters);
        this.filterList();
    }
}


// WEBPACK FOOTER //
// ./js/modules/transactions.ts